import template from './sw-extension-store-accessibility.html.twig';
import './sw-extension-store-accessibility.scss';

export default Shopware.Component.wrapComponentConfig({
    template,
});
